export const spaceId: string = 'lo9tz0yvfb24';
export const environmentAlias: string = 'master';
export const accessToken: string = 'depkfLUtfmvdoqMzBtCqMrVKb_ocRmVlVkRqoncn1u8';

export const contentful = require('contentful');
export const client = contentful.createClient({
  space: spaceId,
  environment: environmentAlias, // defaults to 'master' if not set
  accessToken: accessToken
})